import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { useSwipeable } from 'react-swipeable';

const Wrapper = styled.div<{
  pressed: boolean;
  hideClickEffect?: boolean;
  shadows?: Shadows;
}>`
  ${({
    hideClickEffect = false,
    pressed,
    shadows = {
      pressed: '',
      init: '',
    },
  }) => {
    if (hideClickEffect) {
      return '';
    }
    return `
      transform: perspective(500px) translateZ(${pressed ? -15 : 0}px);
      transition: transform 100ms 0ms ease-in-out, box-shadow 0.3s;
      box-shadow: ${pressed ? shadows.pressed : shadows.init};
    `;
  }}
`;

interface Shadows {
  pressed: string;
  init: string;
}
interface Props {
  children?: React.ReactNode;
  disabled?: boolean;
  onClick?: () => void;
  className?: string;
  hideClickEffect?: boolean;
  ref?: (ref: any) => void;
  shadows?: Shadows;
}
const TouchedWrapper = ({ children, disabled, onClick, ...rest }: Props) => {
  const [touching, setTouching] = useState(false);
  let timeout: number;

  useEffect(() => {
    return () => {
      clearTimeout(timeout);
    };
  }, []);

  const handlers = useSwipeable({
    delta: 10,
    onSwiping: () => setTouching(false),
  });

  const onTouchEnd = (e: React.TouchEvent) => {
    e.preventDefault();
    // If the touch started and ended on this item
    if (touching) {
      // Trigger onclick

      if (onClick) {
        onClick();
      }
    }
    timeout = setTimeout(() => {
      setTouching(false);
    }, 100);
  };

  const onTouchStart = (e: React.TouchEvent) => {
    e.stopPropagation();
    // Dont show user feedback if item is unavailable
    if (disabled) {
      return;
    }

    setTouching(true);
  };

  return (
    <Wrapper
      {...handlers}
      {...rest}
      pressed={touching}
      onTouchStart={onTouchStart}
      onTouchEnd={onTouchEnd}>
      {children}
    </Wrapper>
  );
};

export default TouchedWrapper;
